import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown-angular7';
import { BarRatingModule } from 'ngx-bar-rating';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxPrintModule } from 'ngx-print';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { CateringLogsComponent } from '../cateringSection/catering-logs/catering-logs.component';
import { AddEditMemberComponent } from '../MaterialDialogs/add-edit-member/add-edit-member.component';
import { CreateLocationDialogComponent } from '../MaterialDialogs/create-location-dialog/create-location-dialog.component';
import { ReasonDisplayDialogComponent } from '../MaterialDialogs/reason-display-dialog/reason-display-dialog.component';
import { ReassignRoleDialogComponent } from '../MaterialDialogs/reassign-role-dialog/reassign-role-dialog.component';
import { MemberPreferenceModelComponent } from '../pages/service-request/service-request-modal/member-preference-model/member-preference-model.component';
import { DateCheckerPipe } from '../pipe/check-date-format.pipe';
import { ConvertMilisecondsToDurationPipe } from '../pipe/convert-miliseconds-to-hours-minutes-seconds.pipe';
import { ConvertTimeSpanPipe } from '../pipe/convert-time-span.pipe';
import { CustomNumberFormatPipe } from '../pipe/custom-number-format.pipe';
import { DurationCalculationPipe } from '../pipe/duration-calculation-pipe';
import { SearchFilesByCategoryPage } from '../pipe/fileFilter';
import { FilterPipe } from '../pipe/filter.pipe';
import { FlightAwairRedirectionPipe } from '../pipe/flight-awair-rediraction.pipe';
import { HeightMaskPipe } from '../pipe/heightmask.pipe';
import { HourMinutePipe } from '../pipe/hour-minute.pipe';
import { TimeConvertionPipe } from '../pipe/hourMinConverstion.pipe';
import { NumberToHourMinuteConversionPipe } from '../pipe/number-to-hour-minute-conversion.pipe';
import { OrderByPipe } from '../pipe/order-by.pipe';
import { PhoneNumberPipe } from '../pipe/phonenumber.pipe';
import { QuantityConversionPipe } from '../pipe/quantity-conversion.pipe';
import { SearchFilesByCategory } from '../pipe/searchByCategory.pipe';
import { SearchFilter } from '../pipe/searchFilter.pipe';
import { SecondsToTimestampPipe } from '../pipe/seconds-to-timestamp.pipe';
import { FormatedatePipe } from '../pipe/UTCTime.pipe';
import { AddContactComponent } from '../ReusableComponent/add-contact/add-contact.component';
import { AddEditVehicleComponent } from '../ReusableComponent/add-edit-vehicle/add-edit-vehicle.component';
import { AddressManagementFilterComponent } from '../ReusableComponent/address-management-filter/address-management-filter.component';
import { AssignmentRequestComponent } from '../ReusableComponent/assignment-request/assignment-request.component';
import { BlockTimeReportComponent } from '../ReusableComponent/block-time-report/block-time-report.component';
import { CustomerEditDialogComponent } from '../ReusableComponent/editCustomer/customerEdit.component';
import { EditVendorComponent } from '../ReusableComponent/editVendorDetail/editVendor.component';
import { FileComponent } from '../ReusableComponent/fileUpload/fileUpload.component';
import { InvoiceStatusReportComponent } from '../ReusableComponent/invoice-status-report/invoice-status-report.component';
import { JourneyTrackerComponent } from '../ReusableComponent/journey-tracker/journey-tracker.component';
import { LegDetailsComponent } from '../ReusableComponent/leg-details/leg-details.component';
import { NoteFileModalComponent } from '../ReusableComponent/note-file-modal/note-file-modal.component';
import { ReadMoreComponent } from '../ReusableComponent/read-more/read-more.component';
import { ReusableFilterComponent } from '../ReusableComponent/reusable-filter/reusable-filter.component';
import { ReusableNotesComponent } from '../ReusableComponent/reusable-notes/reusable-notes.component';
import { TripReportComponent } from '../ReusableComponent/trip-report/trip-report.component';
import { ANGULAR_MATERIAL_MODULES } from './angular-material-modules';
import { IntegerOnlyDirective } from './directives/integer-only.directive';
import { NoConsecutiveSpacesDirective } from './directives/no-consecutive-spaces.directive';
import { PreventPipesDirective } from './directives/prevent-pipes.directive';
import { PreventSpacesDirective } from './directives/prevent-spaces.directive';
import { NumbersOnlyDirective } from '../shared/directives/numbers-only.directive';
import { ToLocalDatePipe } from '@pipes/to-local-date/to-local-date.pipe';
import { BlockTimeReportGridComponent } from '../ReusableComponent/block-time-report/components/block-time-report-grid/block-time-report-grid.component';
import { ServiceRequestTemplateModule } from '@modules/service-request-template/service-request-template.module';

const modules = [
  CommonModule,
  NgMultiSelectDropDownModule,
  SelectDropDownModule,
  NgxPaginationModule,
  FormsModule,
  ReactiveFormsModule,
  NgxPrintModule,
  BarRatingModule,
  ServiceRequestTemplateModule,
  ...ANGULAR_MATERIAL_MODULES,
  BlockTimeReportGridComponent,
];

const components = [
  SearchFilesByCategoryPage,
  SearchFilesByCategory,
  LegDetailsComponent,
  ReusableNotesComponent,
  ReusableFilterComponent,
  NoteFileModalComponent,
  EditVendorComponent,
  AddEditVehicleComponent,
  AddEditMemberComponent,
  FileComponent,
  TripReportComponent,
  AssignmentRequestComponent,
  ReadMoreComponent,
  JourneyTrackerComponent,
  MemberPreferenceModelComponent,
  BlockTimeReportComponent,
  InvoiceStatusReportComponent,
  AddContactComponent,
  AddressManagementFilterComponent,
  CateringLogsComponent,
];

const pipes = [
  FilterPipe,
  OrderByPipe,
  FormatedatePipe,
  PhoneNumberPipe,
  TimeConvertionPipe,
  HourMinutePipe,
  HeightMaskPipe,
  QuantityConversionPipe,
  SearchFilter,
  ConvertTimeSpanPipe,
  ConvertMilisecondsToDurationPipe,
  DurationCalculationPipe,
  SecondsToTimestampPipe,
  NumberToHourMinuteConversionPipe,
  CustomNumberFormatPipe,
  FlightAwairRedirectionPipe,
  DateCheckerPipe,
  ToLocalDatePipe,
];

const matDialogs = [CreateLocationDialogComponent, CustomerEditDialogComponent, ReassignRoleDialogComponent, ReasonDisplayDialogComponent];

const directives = [PreventSpacesDirective, NoConsecutiveSpacesDirective, PreventPipesDirective, IntegerOnlyDirective];

@NgModule({
  declarations: [components, pipes, matDialogs, directives],
  imports: [modules, NumbersOnlyDirective],
  exports: [modules, components, pipes, matDialogs, directives],
})
export class SharedUiModule {}
